import { jsx as _jsx } from "react/jsx-runtime";
import { assertDefined, } from '@tymia/shared';
import { StrictMode, } from 'react';
import { createRoot, } from 'react-dom/client';
import { App, } from './App.js';
const container = document.getElementById('root');
assertDefined(container);
const root = createRoot(container);
root.render(_jsx(StrictMode, { children: _jsx(App, {}) }));
//# sourceMappingURL=index.js.map